module.exports = __webpack_public_path__ + "b331d2c9bde34533aa89bb4de9d16dcd.pdf";